//level 2 if the name is # not display others display the label as the title
const l2menu_selectors = document.querySelectorAll(".mega-menu__link--level-2");
for (i = 0; i < l2menu_selectors.length; ++i) {
  l2menu_selector = l2menu_selectors[i];
  l2menu_selector_content = l2menu_selector.textContent.trim();
  if (l2menu_selector_content === "#") {
    l2menu_selector.style = "display: none";
  } else {
    l2menu_selector.style.cssText = "pointer-events: none; cursor: default;";
  }
}

// mega menu on hover
let items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");
items.forEach((item) => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("summary").setAttribute("aria-expanded", "true");
    item.addEventListener("mouseout", () => {
      item.removeAttribute("open");
      item.querySelector("summary").setAttribute("aria-expanded", "false");
    });
  });
});
